import { render, staticRenderFns } from "./ViewComplianceForm.vue?vue&type=template&id=60abf754&"
import script from "./ViewComplianceForm.vue?vue&type=script&lang=js&"
export * from "./ViewComplianceForm.vue?vue&type=script&lang=js&"
import style0 from "./ViewComplianceForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports